import { useState } from "react";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { API_URL } from "../../../../core/config/env";
import Datatable from "../../../../core/ui/components/Datatable";
import ContentWrapper from "../../../../core/ui/components/Layout/ContentWrapper";
import { sweetAl } from "../../../../core/helpers/message-helper";
import useModal from "../../../../core/hooks/use-modal";
import useUser from "../../../../core/hooks/use-user";
import {
    activarEntidadSalud,
    inactivarEntidadSalud,
} from "../../services/entidades-salud-service";
import FormEntidadesSalud from "../components/form-entidades-salud";

const EntidadesSalud = () => {
    const { getAccessToken, userCan } = useUser();
    const token = getAccessToken();
    const [dtInstance, onDtInstance] = useState();

    const modalEntidadSalud = useModal({
        title: "Crear la Entidad de Salud",
        data: { entidadSalud: {} },
    });

    const getDtInstance = (dt) => onDtInstance(dt);

    const onSaved = () => {
        dtInstance.ajax.reload();
    };

    let tableButtons = [];

    if (userCan("crearEntidadesSalud")) {
        tableButtons.push({
            titleAttr: "Agregar Entidad de Salud",
            text: '<i class="fas fa-plus"></i>',
            action: function () {
                modalEntidadSalud.open({
                    title: "Agregar Entidad de Salud",
                    data: { entidadSalud: {} },
                });
            },
            className: "btn btn-sm btn-secondary",
        });
    }

    if (userCan("editarEntidadesSalud")) {
        tableButtons.push({
            titleAttr: "Editar Entidad de Salud",
            text: '<i class="fas fa-pen"></i>',
            action: async (_, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                modalEntidadSalud.open({
                    title: "Editar Entidad de Salud",
                    data: { entidadSalud: data },
                });
            },
            className: "btn btn-sm btn-grey",
        });
    }

    if (userCan("inactivarEntidadesSalud")) {
        tableButtons.push({
            titleAttr: "Inactivar Entidad de Salud",
            text: '<i class="fas fa-trash"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea inactivar esta Entidad de Salud?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        eliminar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha inactivado la Entidad de Salud"
                        );
                        break;
                    case "eliminar": {
                        const resp = await inactivarEntidadSalud(data.id);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al inactivar la Entidad de Salud"
                            );
                        }

                        sweetAl.success(
                            "La Entidad de Salud fue inactivada correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-danger",
        });
    }

    if (userCan("activarEntidadesSalud")) {
        tableButtons.push({
            titleAttr: "Activar Entidad de Salud",
            text: '<i class="fas fa-check"></i>',
            action: async (e, dt) => {
                const data = dt.row({ selected: true }).data();
                if (!data) return;

                const value = await swal({
                    title: "Confirmación",
                    text: `¿Seguro que desea activar esta Entidad de Salud?`,
                    icon: "info",
                    buttons: {
                        cancelar: {
                            text: "Cancelar",
                            className: "btn-danger",
                        },
                        activar: {
                            text: "Aceptar",
                            className: "btn-success",
                        },
                    },
                });

                switch (value) {
                    case "cancelar":
                        sweetAl.warning(
                            "No se ha activado la Entidad de Salud"
                        );
                        break;
                    case "activar": {
                        const resp = await activarEntidadSalud(data);
                        if (!resp.status) {
                            return sweetAl.error(
                                "Ha ocurrido un error al activar la Entidad de Salud"
                            );
                        }

                        sweetAl.success(
                            "La Entidad de Salud fue activado correctamente"
                        );
                        dt.ajax.reload();
                        break;
                    }
                }
            },
            className: "btn btn-sm btn-primary",
        });
    }

    tableButtons = [
        ...tableButtons,
        {
            titleAttr: "Exportar a Excel",
            text: '<i class="fas fa-file-excel"></i>',
            extend: "excelHtml5",
            className: "btn btn-sm btn-success",
            exportOptions: {
                modifier: {
                    order: "current",
                    page: "all",
                },
            },
            filename: "tipo-parametros",
        },
        {
            titleAttr: "Imprimir",
            text: '<i class="fa fa-lg fa-print"></i>',
            extend: "print",
            className: "btn btn-sm btn-warning",
        },
    ];

    const dtOptions = {
        searchable: true,
        serverSide: false,
        dom: "Bfrtip",
        id: "tablaEntidadesSalud",
        select: {
            style: "single",
        },
        buttons: tableButtons,
        ajax: {
            url: `${API_URL}/administrar/entidadesSalud`,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", `Bearer ${token}`);
            },
            type: "get",
            dataType: "json",
            error: function () {
                toast.error(
                    "Ha ocurrido un error listanto las Entidades de Salud"
                );
            },
        },
        columns: [
            { data: "id" },
            { data: "nombre" },
            { data: "nit" },
            { data: "tipo_entidad" },
            { data: "regimen_entidad" },
            { data: "filtrosEntidadSalud" },
            { data: "vistaEventos" },
            { data: "vistaEmpleados" },
            { data: "status" },
        ],
        columnDefs: [
            {
                targets: [6],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Si" : "No";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [7],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Si" : "No";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
            {
                targets: [8],
                createdCell: function (td, cellData) {
                    td.textContent = cellData == 1 ? "Activo" : "Inactivo";
                    td.classList.add(
                        cellData == 1 ? "text-success" : "text-warning"
                    );
                    td.classList.add("text-bold");
                },
            },
        ],
    };

    return (
        <ContentWrapper>
            <div className="content-heading">
                <div>
                    ADMINISTRAR / Entidades De Salud</div>
            </div>
            <Datatable options={dtOptions} dtInstance={getDtInstance}>
                <table
                    className="w-100 table table-hover"
                    id="tablaEntidadesSalud"
                >
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Nombre</th>
                            <th>Nit</th>
                            <th>Tipo</th>
                            <th>Regimen</th>
                            <th>Filtro</th>
                            <th>Vista Eventos</th>
                            <th>Vista Empleados</th>
                            <th>Estado</th>
                        </tr>
                    </thead>
                </table>
            </Datatable>
            {
                <FormEntidadesSalud
                    modalState={modalEntidadSalud}
                    onSaved={onSaved}
                />
            }
        </ContentWrapper>
    );
};

export default EntidadesSalud;
